import Intercom from "@intercom/messenger-js-sdk";
import { createContext, PropsWithChildren, useContext, useEffect } from "react";

import { extractPrefixedTeamId } from "@smart/bridge-types-basic";
import { isTestEnv } from "@smart/itops-utils-basic";

import { FormsApiResults } from "./api";
import { useUser } from "./user";

const INTERCOM_APP_ID = "c1sbgle1";

export type IntercomContextValue = Record<string, never>;

const intercomContextValue: IntercomContextValue = {};

export const IntercomContext =
  createContext<IntercomContextValue>(intercomContextValue);

export const getFullNameFromUser = (user: FormsApiResults["me"]) =>
  [user.firstName, user.lastName].filter(Boolean).join(" ") || undefined;

export const IntercomProvider = ({ children }: PropsWithChildren) => {
  const { user, intercomUserHash } = useUser();

  useEffect(() => {
    if (isTestEnv() || !user?.userUri || !intercomUserHash) return;

    Intercom({
      app_id: INTERCOM_APP_ID,
      email: user.email,
      name: getFullNameFromUser(user),
      user_id: extractPrefixedTeamId(user.userUri, "sb").id,
      user_hash: intercomUserHash,
    });
  }, [user, intercomUserHash]);

  return (
    <IntercomContext.Provider value={intercomContextValue}>
      {children}
    </IntercomContext.Provider>
  );
};

export const useIntercom = () => {
  useContext(IntercomContext);

  return {};
};
